import React, { Component } from "react";
import { connect } from "react-redux";
import { changeLocInfoAction, changeDistAction } from "../redux/app/actions";
import { openTopBtnSwAction } from "../redux/ui/actions";
import IconBtn from "./common/IconBtn";
import Bmap from "./topBtn/Bmap";
import LocInfo from "./topBtn/LocInfo";
import Dist from "./topBtn/Dist";
import WData from "./topBtn/wData";
import BColor from "./topBtn/BColor";
import Source from "./topBtn/Source";

const mapStateToProps = (state) => {
    return {
        editerMode: state.appReducer.editerMode,
        region: state.modelAreaReducer.region,
        swCat: state.uiReducer.swCat,
        topBtnSwCat: state.uiReducer.topBtnSwCat,
        userLicense: state.appReducer.userLicense,
    };
};

class TopBtn extends Component {
    constructor(props) {
        super(props);
        this.changeSw = this.changeSw.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.editerMode !== this.props.editerMode) {
            if (this.props.editerMode === 1) {
                //描画モード（モデル領域・断面ライン等）の場合
                this.endDraw(this.props.swCat === "csLine" ? false : true);
                this.props.dispatch(openTopBtnSwAction(null));
            }
        }
    }

    /*
     * ボタンクリック
     * @since hara 2021-02-16
     */
    changeSw(e, cat) {
        if (cat === "locInfo" && this.props.editerMode !== 0) return;
        if (cat === "bColor" && this.props.region === "0") {
            alert("学習領域を作成してください。");
            return;
        }
        if (cat === "dist" && window.getDrawingFlag()) {
            return;
        }

        this.props.dispatch(openTopBtnSwAction(e.target.checked ? cat : null));
        this.endDraw(true);
    }

    /*
     * 描画（地点情報・距離計測・ボーリングカラー）終了
     * @param {Boolean} isNormalView true=最小ズームレベルを通常とする/
     * false=最小ズームレベルを描画用とする
     * @since hara 2020-10-19
     */
    endDraw(isNormalView) {
        window.endLocInfo();
        this.props.dispatch(changeLocInfoAction([0, 0]));

        window.endDist();
        this.props.dispatch(changeDistAction(0));

        window.delBoringDist();
        //if (isNormalView) window.setNormalView();
    }

    render() {
        let cont = null;
        switch (this.props.topBtnSwCat) {
            case "bmap":
                cont = <Bmap />;
                break;
            case "locInfo":
                cont = <LocInfo />;
                break;
            case "dist":
                cont = <Dist />;
                break;
            case "bColor":
                cont = <BColor />;
                break;
            case "wData":
                cont = <WData />;
                break;
            case "source":
                cont = <Source />;
                break;
        }

        return (
            <div className="TopBtnWrap">
                <IconBtn ID="topBtn_bmapChk" class="bmapBtn" change={(e) => this.changeSw(e, "bmap")} checked={this.props.topBtnSwCat === "bmap"} title="ベースマップ" />
                {this.props.userLicense === 0 && (
                    <IconBtn ID="topBtn_wDataChk" class="bColorBtn" change={(e) => this.changeSw(e, "wData")} checked={this.props.topBtnSwCat === "wData"} title="表示データ" />
                )}
                <IconBtn ID="topBtn_locInfoChk" class="locInfoBtn" change={(e) => this.changeSw(e, "locInfo")} checked={this.props.topBtnSwCat === "locInfo"} title="地点情報" />
                <IconBtn ID="topBtn_distChk" class="distBtn" change={(e) => this.changeSw(e, "dist")} checked={this.props.topBtnSwCat === "dist"} title="距離計測" />
                <IconBtn ID="topBtn_sourceChk" class="sourceBtn" change={(e) => this.changeSw(e, "source")} checked={this.props.topBtnSwCat === "source"} title="データの出典" />
                {/*<IconBtn ID='topBtn_bColorChk' class='bColorBtn' change={e => this.changeSw(e, 'bColor')} checked={this.props.topBtnSwCat === 'bColor'} title='ボーリングカラー' />*/}
                {/*★公開版で削除*/}
                {cont}
            </div>
        );
    }
}

export default connect(mapStateToProps)(TopBtn);
